module.exports = __webpack_public_path__ + "static/media/samfooterlogo.74286d4b.svg";